import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvPassagemMensalFiltroComponent } from './rmpv-passagem-mensal-filtro/rmpv-passagem-mensal-filtro.component';
import { RmpvPassagemMensalComponent } from './rmpv-passagem-mensal.component';
import { RmpvPassagemMensalService } from './service/rmpv-passagem-mensal.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  providers: [
    RmpvPassagemMensalService
  ],
  declarations: [
    RmpvPassagemMensalComponent,
    RmpvPassagemMensalFiltroComponent
  ]
})
export class RmpvPassagemMensalModule { }
